import { useEffect } from 'react'

/**
 * 
 *   // Reset first representation dependent fields if not 'yes'
   useResetDependentFields(
     formik,
     'representationFiled',
     ['yes'],
     ['representationStatus', 'decisionDate', 'decisionOutcome']
   )
 
 * useResetDependentFields
 * @param {object} formik - formik instance
 * @param {string} triggerField - the field whose value triggers reset
 * @param {any[]} validValues - array of values where dependentFields are kept
 * @param {string[]} dependentFields - fields to reset when triggerField not in validValues
 */
export const useResetDependentFields = (
  formik,
  triggerField,
  validValues,
  dependentFields
) => {
  useEffect(() => {
    if (!validValues.includes(formik.values[triggerField])) {
      dependentFields.forEach((field) => {
        formik.setFieldValue(field, '', false)
        formik.setFieldTouched(field, false, false)
        formik.setFieldError(field, undefined)
      })
    }
  }, [formik.values[triggerField]])
}

export const useResetDependentFields2 = (
  formik,
  triggerField,
  validValues,
  dependentFields
) => {
  useEffect(() => {
    if (validValues.includes(formik.values[triggerField])) {
      dependentFields.forEach((field) => {
        formik.setFieldValue(field, '', false)
        formik.setFieldTouched(field, false, false)
        formik.setFieldError(field, undefined)
      })
    }
  }, [formik.values[triggerField]])
}
